// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollButton_button__QHvjC","buttonLeft":"ScrollButton_buttonLeft__cog8A","icon":"ScrollButton_icon__MIIek"};